import Character from "@lss/common/src/shell/Character";
import { TimageINT } from "../../src/store/slices/gameObjectSlice";
import { parseRequire } from "../../src/utils/parseImageUrl";
import { images } from "../story/images";


interface JoeINT {
    v4DrankDrug: boolean;
}

const joeProperties: JoeINT = {
    v4DrankDrug: false
};

export const joe = new Character<JoeINT>("Joe", joeProperties, "#6391FFFF");
